export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.BASE_URL || '/'}sw.js`)
      .then((registration) => {
        // 有新 SW 时尽快切换，避免长期停在旧缓存
        registration.update()
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        }
        registration.addEventListener('updatefound', () => {
          const worker = registration.installing
          if (!worker) return
          worker.addEventListener('statechange', () => {
            if (worker.state === 'installed' && navigator.serviceWorker.controller) {
              worker.postMessage({ type: 'SKIP_WAITING' })
            }
          })
        })
      })
      .catch((error) => {
        console.warn('Service Worker注册失败:', error)
      })

    navigator.serviceWorker.addEventListener('controllerchange', () => {
      // 新 SW 接管后刷新一次，拿到最新资源
      if (registerServiceWorker._reloading) return
      registerServiceWorker._reloading = true
      window.location.reload()
    })
  })
}
